module.exports = __webpack_public_path__ + "img/confirmshaming.f4617672.png";